<div style="height: calc(100vh - 92px - 25px - 30px);">

  <button style="float: right; margin-top: 10px; margin-bottom: 10px;" class="btn btn-primary top-button" [disabled]="!isLicenseValid" (click)="addNew()">
    <i class="fa fa-plus-square-o"></i> Add Link
  </button>

  <div style="height: 44px;">
  </div>

  <!--<div style="float: right; margin-top: 10px; margin-bottom: 15px; margin-left: 10px;">
  <button class="btn btn-primary top-button" [disabled]="!isLicenseValid" (click)="addNew()">
    <i class="fa fa-plus-square-o"></i> Add Link
  </button>
  <button class="btn btn-danger btn-primary top-button" [disabled]="!isLicenseValid" (click)="deleteLinks()">
    <i class="pi pi-trash"></i> Delete Selected Links
  </button>
</div>-->

@if (!target || !target.HasUserLinks) {
  <div
    style="text-align: center; padding-top: 0px; padding-bottom: 50px; font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: x-large;">
    Click &quot;Add Link&quot; to create a new manual link
  </div>
}

@if (target && target.HasUserLinks) {
  <p-table [value]="userLinks" [resizableColumns]="true"
    [scrollable]="true" scrollHeight="calc(100vh - 92px - 20px - 66px - 30px)">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Source Link</th>
        <th pResizableColumn style="flex: 0 0 150px;">Source IF Index</th>
        <th pResizableColumn>Target Link</th>
        <th pResizableColumn style="flex: 0 0 150px;">Target IF Index</th>
        <th class="uv-table-button-column-1"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>
          <span class="uv-table-value">{{ rowData.Source.Description }}</span>
        </td>
        <td style="flex: 0 0 150px;">
          <span class="uv-table-value">{{ rowData.Source.IfIndex }}</span>
        </td>
        <td>
          <span class="uv-table-value">{{ rowData.Target.Description }}</span>
        </td>
        <td style="flex: 0 0 150px;">
          <span class="uv-table-value">{{ rowData.Target.IfIndex }}</span>
        </td>
        <td class="uv-table-button-column-1">
          <button class="btn btn-danger uv-first-table-button" title="Delete this link"
            [disabled]="!isLicenseValid" (click)="deleteLink(rowData)">
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
}

<new-user-link-dialog [display]="displayNewDialog"
  [target]="target"
  (onSuccess)="rebuildUserLinks()"
  (onClose)="onNewDialogClose()">
</new-user-link-dialog>

</div>
